import React from 'react';
import type { ForwardValuationWidgetConfig } from './types';
import { definition } from './index';

interface Props {
  config: Partial<ForwardValuationWidgetConfig>;
  onChange: (config: ForwardValuationWidgetConfig) => void;
}

const ForwardValuationWidgetBuilder: React.FC<Props> = () => (
  <div className="space-y-4">
    <div className="bg-warning-50 border border-warning-200 rounded-lg p-4 text-sm text-warning-800">
      <strong>{definition.meta.label}</strong>
      <p className="mt-1">{definition.meta.description}</p>
    </div>
    <div className="border rounded-lg p-4 bg-primary-50 border-primary-200">
      <h4 className="font-medium text-primary-800 mb-2">How it works</h4>
      <ul className="text-sm text-primary-700 space-y-1 ml-5 list-disc">
        <li>Consensus forward EPS / EBITDA from the FMP analyst feed</li>
        <li>Expressed as forward P/E and EV/EBITDA at the current price</li>
        <li>NTM (nearest year) plus the next out-years</li>
      </ul>
    </div>
  </div>
);

export default ForwardValuationWidgetBuilder;
